export enum SearchStatesEnum {
    none = 'none',
    loading = 'loading',
    success = 'success',
    error = 'error'
}
